const ensureLeadingSlash = (path: string) => (path.startsWith("/") ? path : `/${path}`);

export const pathToAbsoluteUrl = (path: string, basePath: string): string => {
  try {
    if (/^https?:\/\//.test(path)) {
      return path;
    }
    const { origin } = new URL(window.location.toString());

    const mergedPath = `${ensureLeadingSlash(basePath)}${ensureLeadingSlash(path)}`;

    return `${origin}${mergedPath}`;
  } catch {
    return path;
  }
};
